exports.pbkdf2 = require('./lib/async')
exports.pbkdf2Sync = require('./lib/sync')



//////////////////
// WEBPACK FOOTER
// ./~/_pbkdf2@3.0.17@pbkdf2/browser.js
// module id = wTOR
// module chunks = 0